export default "__VITE_ASSET__cc2580fc__"